import React, { Component } from 'react';
import WebapiCommon from '../../../app/common/util/webapi.common';
import EditorPage from './editor.page';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '../../../app/common/common.action';
import * as certificacaoActions from '../../../app/common/certificacao/certificacao.action';
import * as editorActions from './editor.action';
import { acessoPermitido } from '../../../acessos.seguranca';
import * as acessos from '../../../acessos.const.util';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import { LOCAL_STORAGE_TOKEN, removerTextoLaudoAutoSave, adicionarTextoLaudoAutoSave } from '../../../localStorage.util';
import LaudoPreview from '../Preview';
import * as liberarParcialActions from '../modais/liberacao_parcial/store/liberacao.action';
import ModalLiberacaoParcial from '../modais/liberacao_parcial';
import ModalLiberacaoTotal from '../modais/liberacao_total';
import { etapasEnum, statusEtapasEnum } from '@common/util/defaultValues';
import { editorPath, editorRunat, editorUrl } from '@constants/defaultValues';
import IntlMessage from '../../../helpers/intlMessage'
import { addCustomButton, mudarNomeAbaPrincipal, recuperarTextoParaAutoSave } from './editor.util';
import { getFontePadrao } from '../../../../src/localStorage.util';

class EditorContainer extends Component {
	constructor(props) {
		super(props);
		this.handlerEvent = this.handlerEvent.bind(this);
		this.autosave = this.autosave.bind(this);
		this.loading = true;
		this.state = {
			stringRtf: '',
			cabecalhoRodape: '',
			showPreview: false,
			intervalId: undefined,
			intervalAutoSave: undefined,
			showIconSave: false,
			modalConfirmar: false,
			modalConfirmarTitulo: <IntlMessage id="dashboards.examDetail.headsUp" />,
			modalConfirmarMensagem:
				'O Editor não consegue se comunicar com o servidor,\n esse erro pode ter sido causado por um timeout por tempo de inatividade\n você será redirecionado para a pagina login, se o problema persistir,\n contate o administrador do sistema.',
			modalConfirmarClick: () => {
				this.redirecionareFecharModal();
			}
		};
	}

	componentDidMount() {
		let laudo = this.props.detalhes && this.props.detalhes.laudo;
		WebapiCommon.obterCabecalhoERodape(laudo).then(response => {
			return this.props.editorActions.editorHeaderFooter(response);
		});
		window.addEventListener('message', this.handlerEvent);
		window.addEventListener('keydown', this.updateAtalho.bind(this));
		this.props.modalLiberarActions.obterConfiguraco();

		//  let intervalAutoSave = setInterval(() => {
		// 	recuperarTextoParaAutoSave()
		// }, 30000);

		// this.setState({intervalAutoSave: intervalAutoSave});
	}

	componentWillUnmount() {
		window.removeEventListener('message', this.handlerEvent);
		// clearInterval(this.state.intervalAutoSave);
		// this.setState({intervalAutoSave: undefined});

		// this.props.detalhes.etapas.map(element => {
		// 	removerTextoLaudoAutoSave("texto_" + this.props.detalhes.laudo.toString() + "_" + element.etapa.toLowerCase());
		// });

		commonActions.atualizarDetalhes(undefined);
	}

	redirecionareFecharModal = () => {
		localStorage.removeItem(LOCAL_STORAGE_TOKEN);
		window.location.replace('/login');
	};

	getAltura = () => {
		return (
			document.getElementById('container-editor') &&
			document.getElementById('container-editor').style.height
		);
	};

	getTotalCertificadosPendentes() {
		WebapiCommon.getTotalCertificadosPendentes().then((result) => {
			this.props.certificacaoActions.totalPendentes(result);
		});
	}

	autosave = () => {
		if (
			this.props.autosaveEditor &&
			!this.props.exameFinalizado &&
			this.getStatusEtapa() !== 'realizado'
		) {
			this.setState({ showIconSave: true });
			setTimeout(() => this.setState({ showIconSave: false }), 500);
			if (this.props.editorCarregado) {
				const frame = document.getElementById('iframe-editor');
				frame.contentWindow.postMessage(
					{
						method: 'recuperarTextoRtf',
						urlHost: editorUrl,
						args: {
							action: 'autosave'
						}
					},
					editorUrl
				);
			}
		}
	};

	carregarEditor() {
		this.props.commonActions.editorInicializado(false);
		this.props.commonActions.editorCarregado(false);
		window.$editor_carregado = false;
		this.props.commonActions.eventokeyUpFoiDisparadoNoEditor(false);
		const frame = document.getElementById('iframe-editor');

		let idiomaEditor= '';

		switch (this.props.lang) {
		  case 'es':
			idiomaEditor =  'es-ES';
			break;
			case 'en':
			idiomaEditor = 'en-US';
			break;
		  default:
			idiomaEditor = 'pt-BR'
		  }

		console.log('inicializando editor language:', idiomaEditor);

		if (frame !== null) {
			try {
				frame.contentWindow.postMessage(
					{
						method: 'monitorarLifeCycle',
						urlHost: editorUrl
					},
					editorUrl
				);

				let idiomaEditor= '';

				switch (this.props.lang) {
					case 'es':
						idiomaEditor =  'es-ES';
						break;
					 case 'en':
					  idiomaEditor = 'en-US';
						break;
					default:
						idiomaEditor = 'pt-BR'
				  }

				console.log('inicializando editor language:', idiomaEditor);

				frame.contentWindow.postMessage(
					{
						method: 'inicializarEditor',
						language: idiomaEditor,
						urlHost: editorUrl,
						defaultFontName: getFontePadrao(),
						defaultFontSize: 12,
						defaultMargin: [2.5, 3, 2.5, 3], //[top, left, bottom, right] em centímetros Padrão ABNT
						initTextRtf: '',
						enableHeadersAndFooters: true,
						enableReferencesTab: false,
						enableViewTab: false,
						headerFooterRtf: this.props.cabecalhoRodape, //this.props.cabecalhoRodape
						theme: 'Material',
						width: '100%',
						height: '630px',
						ribbonMode: 4,
						readOnly: false
					},
					editorUrl
				);

				frame.contentWindow.postMessage(
					{
						method: 'setAutoTextEnable',
						enable: true,
						urlHost: editorUrl
					},
					editorUrl
				);
			} catch (error) {
				console.log(error);
				this.carregarEditor();
			}
		}
	}

	getStatusEtapa() {
		let etapa = this.props.detalhes.etapas.find(
			el => el.etapa.toLowerCase() === this.props.etapaAtual
		);
		const result = etapa !== null ? etapa.status : '';
		return result;
	}

	updateAtalho(event) {
		if (
		  event.altKey &&
		  event.key !== 'Alt' &&
		  event.ctrlKey &&
		  event.key !== 'Ctrl' &&
		  this.props.detalhes
		) {
		  this.props.commonActions.preencherAtalho('ctrl+alt+' + event.key);
		}
	  }

	handlerEvent = event => {


		// if (
		// 	`${event.origin}/${editorPath}` !==
		// 	editorUrl
		// ) {
		// 	return;
		// }

		// if (event.data.value === 'DocumentLoaded') {
		// 	console.log('carregou o editor');
		// }


		// if (event.data.value !== 'editor') {
		// 	return;
		// }

		// if (development) {
		//   console.warn(
		//     `${event.data.key} : ${
		//       event.data.value
		//     } ${new Date().toLocaleTimeString()}`
		//   );
		// }

		if (
			event.data.key === 'RegisterMessage' &&
			event.data.value === 'CallbackError'
		) {
			this.setState({
				modalConfirmar: !this.state.modalConfirmar
			});
		}

		const frame = document.getElementById('iframe-editor');

		if (
			event.data.value === 'DocumentLoaded'
		) {
			window.$editor_carregado = true;
			if (this.props.detalhes) {
				this.props.commonActions.editorInicializado(true);
				mudarNomeAbaPrincipal('Formatação');
				/* addCustomButton('btnLaudar', 'Laudar', 'doc', false, false, 'tab-tools', 'Ações', 0, 'true');
				addCustomButton('btnRevisar', 'Revisar', 'check', false, false, 'tab-tools', 'Ações', 2, 'true');
				addCustomButton(
					'btnLaudarRevisar',
					'Laudar/Revisar',
					'exportselected',
					false,
					false,
					'tab-tools',
					'Ações',
					1,
					'true',
				);
				addCustomButton(
					'btnUrgente',
					'Urgente',
					'warning',
					true,
					false,
					'tab-tools',
					'Ações',
					0,
					'true',
					true,
					true//isUrgent,
				);
				addCustomButton(
					'btnPendente',
					'Pendente',
					'clock',
					false,
					false,
					'tab-tools',
					'Ações',
					0,
					'true',
					true,
					true//isPendente,
				);
				addCustomButton(
					'btnProvisorio',
					'Provisório',
					'export',
					false,
					false,
					'tab-tools',
					'Ações',
					0,
					'true',
					true,
					true//isProvisory,
				);
				addCustomButton(
					'btn3Opiniao',
					'3° Opinião',
					'comment',
					false,
					false,
					'tab-tools',
					'Ações',
					0,
					'true',
					true,
					true//is3Opiniao,
				);
				addCustomButton(
					'btnLimparFormula',
					'Limpar Fórmula',
					'clearformat',
					false,
					false,
					'tab-tools',
					'Ações',
					3,
					'true',
				); */
			}
		}

		if (
			event.data.key === 'RegisterMessage' &&
			event.data.value === 'DocumentChanged'
		) {
			if (this.props.textoInicial) {
				this.props.commonActions.textoInicial(false);
			} else {
				this.props.commonActions.eventokeyUpFoiDisparadoNoEditor(true);
			}
		}

		if (
			event.data.key === 'RegisterMessage' &&
			event.data.value === 'BeginCallback'
		) {
			window.$editor_begincallback = true;
		}

		if (
			event.data.key === 'RegisterMessage' &&
			event.data.value === 'EndCallback' &&
			window.$editor_begincallback
		) {
			window.$editor_begincallback = false;
			this.props.commonActions.showFadeCarregando(false);
		}

		if (
			window.$editor_carregado &&
			event.data.key === 'RegisterMessage' &&
			event.data.value === 'EndSynchronization' &&
			!window.$editor_begincallback
		) {
			this.props.commonActions.showFadeCarregando(false);
		}

		if (event.data.key === 'TextoLaudoRtf') {
			this.props.commonActions.changeRtf(event.data.value);
			let status = this.getStatusEtapa();

			if (
				!this.props.exameFinalizado &&
				this.props.etapaAtual !== undefined &&
				event.data.args.action === 'autosave' &&
				status !== 'realizado' &&
				acessoPermitido(this.props.usuario, acessos.Editar) &&
				acessoPermitido(this.props.usuario, acessos.Macroscopia)
			) {
				WebapiCommon.atualizarTexto(
					this.props.detalhes.laudo,
					atob(event.data.value),
					this.props.etapaAtual.toLowerCase(),
					'',
					status,
					false
				).then(() => {
					this.props.commonActions.atualizarDetalhes(undefined);
					this.props.commonActions.editorInicializado(false);
					this.props.commonActions.eventokeyUpFoiDisparadoNoEditor(false);
					this.props.commonActions.showFadeCarregando(false);

					let msg = this.props.mensagem;
					let tipo = this.props.tipo;
					let time = 5000;

					if (!msg) {
						msg = 'Texto do laudo salvo com sucesso';
						tipo = 'sucesso';
						time = 4000;
					}

					this.props.commonActions.showAlerta(
						tipo,
						msg,
						time,
						msg.length * 10 + 'px'
					);

					setTimeout(() => {
						setTimeout(() => {
							this.getTotalCertificadosPendentes();
						}, 1000);
						this.props.history.goBack();
					}, time);
				});
			}
		}

		if (event.data.key === 'TextoHeaderFooterRtf') {
			this.props.editorActions.editorHeaderFooter(atob(event.data.value));
			if (event.data.args && event.data.args.action === 'getTextPreview') {
				this.setState({ stringRtf: event.data.value });
				this.setState({ showPreview: true });
			}
		}

		if (event.data.key === 'RtfSubstituido') {
			console.log('<-- evento que substitiu os dados do editor acionado -->');
		}

		if (event.data.key === 'ConvertRtfToPlainText') {
			this.props.commonActions.preencherPlainText(event.data.value);
			this.props.commonActions.showFadeCarregando(false);
		}

		if (event.data.key === 'RecuperarTextoRtfAndPlainText' && event.data.args.action === 'getTextPreview') {
			this.setState({ stringRtf: event.data.value.rtf });
			this.setState({ showPreview: true });

		} else if (event.data.key === 'RecuperarTextoRtfAndPlainText' && event.data.args.action === 'obterTextoParaAutoSave') {
			let chave = "texto_" + this.props.detalhes.laudo.toString() + "_" + this.props.etapaAtual;

			if (event.data.value.plain.replace(/(\r\n|\n|\r)/gm, "") !== "") {
				adicionarTextoLaudoAutoSave(chave, event.data.value.rtf);
			}
		} else if (event.data.key === 'RecuperarTextoRtfAndPlainText' && event.data.args.action === 'verificarPlainTextMudou'){
			this.props.commonActions.changeRtf(event.data.value.rtf);
			this.props.commonActions.preencherPlainText(event.data.value.plain);
			this.props.commonActions.preencherIdRtf(this.props.laudoTextoId);
		}
		else if (event.data.key === 'RecuperarTextoRtfAndPlainText') {
			const statusEtapa = this.getStatusEtapa();
			// Gravar e Laudar pelo Fab button

			const payload = {
				laudo: this.props.detalhes.laudo,
				texto: atob(event.data.value.rtf),
				etapa: this.props.etapaAtual.toLowerCase(),
				plainText: event.data.value.plain,
				statusEtapa,
				laudoTextoId: this.props.laudoTextoId,
				medicoExecutante: this.props.medExecutante,
				medicoRevisor: this.props.medRevisor,
				headerFooter: this.props.cabecalhoRodape
			};

			// this.props.commonActions.preencherPlainText(event.data.value.plain);
			// this.props.commonActions.changeRtf(event.data.value.rtf);

			if (event.data.args.action === 'getRTFandPlainText') {
				this.props.editorActions.editorRtf(payload.texto);
				this.props.editorActions.editorPlainText(payload.plainText);
				const { titulo, atalho, grupo } = event.data.args.param;

				const dados = {
					titulo,
					atalho,
					rtf: payload.texto,
					nrExame: this.props.detalhes.nrExame,
					grupoId: grupo.value
				};

				WebapiCommon.novoAutoTexto(dados).then(() => {
					let msg = this.props.mensagem;
					let tipo = this.props.tipo;
					let time = 3500;

					if (!msg) {
						msg = 'AutoTexto salvo com sucesso';
						tipo = 'sucesso';
						time = 2000;
					}

					this.props.commonActions.atualizaAutotexto(true);
					this.props.commonActions.showModal(false);
					this.props.commonActions.showAlerta(
						tipo,
						msg,
						time,
						msg.length * 10 + 'px'
					);
				});

				return event.data;
			}

			if (event.data.args.action === 'getPlainText') {
				this.props.editorActions.editorPlainText(payload.plainText);
				return event.data;
			}

			if (event.data.args.action === 'getPlainTextContainer') {
				this.props.editorActions.editorPlainText(payload.plainText);
				return event.data;
			}

			if (event.data.args.action === 'getPlainTextEtapa') {
				this.props.editorActions.editorPlainText(payload.plainText);
				return event.data;
			}

			// if (event.data.args.action === 'getTextPreview') {
			// 	this.setState({ stringRtf: event.data.value.rtf });
			// 	this.setState({ showPreview: true });
			// 	return event.data;
			// }

			WebapiCommon.atualizarTexto(
				payload.laudo,
				payload.texto,
				payload.etapa,
				payload.plainText,
				this.props.status,
				(!payload.laudoTextoId || payload.laudoTextoId === '') ? null : payload.laudoTextoId,
				payload.medicoExecutante,
				payload.medicoRevisor,
				payload.headerFooter
			)
				.then(() => {
					this.props.modalLiberarActions.obterConfiguraco();

					if (event.data.args.action === 'laudar') {
						const laudo = this.props.detalhes.laudo;
						const etapa = this.props.etapaAtual.toLowerCase();
						this.props.commonActions.showFadeCarregando(true);

						WebapiCommon.laudar(laudo, this.props.laudarEtapaRequest, etapa)
							.then(response => {
								const listagem = [...this.props.listagem];
								const listagemIndex = listagem.findIndex(
									item => item.laudo === laudo
								);
								const item = listagem[listagemIndex];
								const etapaIndex = item.etapas.findIndex(
									item =>
										item.etapa.toLowerCase() ===
										this.props.etapaAtual.toLowerCase()
								);

								listagem[listagemIndex].etapas[etapaIndex].status =
									response.data.status;

								this.props.commonActions.preencherListagem(listagem);

								let msg = this.props.mensagem;
								let tipo = this.props.tipo;
								let time = 1000;
								if (!msg) {
									msg = <IntlMessage id="dashboards.examDetail.reportSave" />;
									tipo = 'sucesso';
									time = 2000;
								}

								this.props.commonActions.showAlerta(
									tipo,
									msg,
									time / 2,
									msg.length * 10 + 'px'
								);

								setTimeout(() => {
									this.props.commonActions.showFadeCarregando(false);

									if (
										this.props.etapaAtual.toUpperCase() !== etapasEnum.MACRO &&
										this.props.etapaAtual.toUpperCase() !==
										etapasEnum.MATERIAL &&
										this.props.etapaAtual.toUpperCase() !== etapasEnum.ERRATA
									) {
										let conclusaoHabilitada = this.props.detalhes.etapas.find(
											e => e.etapa === etapasEnum.CONCLUSAO
										).status;

										if (
											(conclusaoHabilitada === statusEtapasEnum.NAO_APLICAVEL &&
												acessoPermitido(
													this.props.usuario,
													acessos.LiberarLaudoParaEntrega
												) &&
												acessoPermitido(
													this.props.usuario,
													acessos.LiberarLaudoParaEntrega
												) && !this.props.laudarEtapaRequest.laudarParaConferencia)
										) {
											setTimeout(() => {
												this.getTotalCertificadosPendentes();
											}, 1000);
											this.props.modalLiberarActions.fecharModal(
												false,
												this.props.liberacaoParcialHabilitada,
												item.laudo
											);
										} else {
											setTimeout(() => {
												this.getTotalCertificadosPendentes();
											}, 1000);
											//return this.props.history.goBack();
										}
									} else {
										setTimeout(() => {
											this.getTotalCertificadosPendentes();
										}, 1000);
										//return this.props.history.goBack();
									}
								}, time);
							})
							.catch(err => {
								console.error(
									`[ERRO no retorno da API / PATCH]: laudos/${laudo}/etapas/${etapa}`,
									err
								);
								return this.props.commonActions.showFadeCarregando(false);
							});
						// return this.props.commonActions.showFadeCarregando(false);

						let chave = "texto_" + this.props.detalhes.laudo.toString() + "_" + this.props.etapaAtual;
						removerTextoLaudoAutoSave(chave);
					}

					if (event.data.args.action === 'laudarConcluir') {
						const laudo = this.props.detalhes.laudo;
						const etapa = this.props.etapaAtual.toLowerCase();
						this.props.commonActions.showFadeCarregando(true);

						WebapiCommon.laudar(laudo, this.props.laudarEtapaRequest, etapa)
							.then(response => {
								const listagem = [...this.props.listagem];
								const listagemIndex = listagem.findIndex(
									item => item.laudo === laudo
								);
								const item = listagem[listagemIndex];
								const etapaIndex = item.etapas.findIndex(
									item =>
										item.etapa.toLowerCase() ===
										this.props.etapaAtual.toLowerCase()
								);

								listagem[listagemIndex].etapas[etapaIndex].status =
									response.data.status;
								listagem[listagemIndex].etapas[9].status =
									response.data.status;
								listagem[listagemIndex].etapas[9].statusFormatado = 'Realizada';
								listagem[listagemIndex].etapas[9].etapaFinalizada = true;
								listagem[listagemIndex].etapas[9].dataEtapa = new Date().toLocaleDateString();
								listagem[listagemIndex].etapas[9].medicoEtapa = this.props.laudarEtapaRequest.medicoEtapa;

								this.props.commonActions.preencherListagem(listagem);

								let msg = this.props.mensagem;
								let tipo = this.props.tipo;
								let time = 1000;
								if (!msg) {
									msg = <IntlMessage id="dashboards.examDetail.reportSave" />;
									tipo = 'sucesso';
									time = 2000;
								}

								this.props.commonActions.showAlerta(
									tipo,
									msg,
									time / 2,
									msg.length * 10 + 'px'
								);

								WebapiCommon.obterStatusEtapasLaudo(laudo).then(
									(etapas) => {
									  this.props.commonActions.atualizarStatusDasEtapasDoLaudo(etapas, laudo);
									}
								  );

								WebapiCommon.getDetalhes(laudo).then(detalhes => {
									this.props.commonActions.atualizarDetalhes(detalhes);
								})

								setTimeout(() => {
									this.props.commonActions.showFadeCarregando(false);

									if (
										this.props.etapaAtual.toUpperCase() !== etapasEnum.MACRO &&
										this.props.etapaAtual.toUpperCase() !==
										etapasEnum.MATERIAL &&
										this.props.etapaAtual.toUpperCase() !== etapasEnum.ERRATA
									) {

										if ((acessoPermitido(
											this.props.usuario,
											acessos.LiberarLaudoParaEntrega
										) &&
											acessoPermitido(
												this.props.usuario,
												acessos.LiberarLaudoParaEntrega
											) && !this.props.laudarEtapaRequest.laudarParaConferencia)
										) {
											this.props.modalLiberarActions.fecharModal(
												false,
												this.props.liberacaoParcialHabilitada,
												item.laudo
											);

										} else {
											setTimeout(() => {
												this.getTotalCertificadosPendentes();
											}, 1000);
											return this.props.history.goBack();
										}
									} else {
										setTimeout(() => {
											this.getTotalCertificadosPendentes();
										}, 1000);
										return this.props.history.goBack();
									}
								}, time);
							})
							.catch(err => {
								console.error(
									`[ERRO no retorno da API / PATCH]: laudos/${laudo}/etapas/${etapa}`,
									err
								);
								return this.props.commonActions.showFadeCarregando(false);
							});
						return this.props.commonActions.showFadeCarregando(false);
					}

					if (event.data.args.action === 'setPlainText') {
						this.props.editorActions.editorPlainText(payload.plainText);
						return event.data;
					}
					if (event.data.args.componente === 'laudos-anteriores.container') {
						WebapiCommon.getTextoLaudo(event.data.args.param, 'final').then(
							final => {
								if (this.props.editorCarregado) {
									frame.contentWindow.postMessage(
										{
											method: 'substituirTexto',
											text: final.data,
											type: 'rtf',
											runat: editorRunat,
											breakLine: false,
											cleanBefore: false
										},
										editorUrl
									);
								}

								this.props.commonActions.showFadeCarregando(false);
								this.props.commonActions.showAlerta(
									'sucesso',
									<IntlMessage id="dashboards.examDetail.reportSave" />,
									2000
								);
							}
						);
					}
				})
				.catch(err => {
					// console.error(err);
					this.props.commonActions.showAlerta(
						'erro',
						'Erro em salvar o Laudo',
						3000
					);
				});
		}

		if (
			this.props.detalhes &&
			window.$editor_carregado &&
			event.data.key === 'RegisterMessage'
		) {
			if (
				event.data.value === 'KeyUp' ||
				event.data.value === 'CharacterPropertiesChanged'
			) {
				this.props.commonActions.eventokeyUpFoiDisparadoNoEditor(true);
			}

			if (
				event.data.value === 'EventKeyPress' &&
				event.data.args !== undefined &&
				event.data.args.atalho !== undefined
			) {
				let promise = new Promise(resolver => {
					if (event.data.args.atalho.length <= 1) {
						resolver('');
					} else {
						WebapiCommon.getAutotexto(
							this.props.detalhes.exameId,
							event.data.args.atalho
						).then(res => resolver(res));
					}
				});

				promise.then(res => {
					let frame = document.getElementById('iframe-editor');
					frame.contentWindow.postMessage(
						{
							method: 'autoTextCallback',
							rtf: res,
							texto: res,
							key: event.data.args.atalho,
							posIni: event.data.args.posIni,
							runat: editorRunat,
							breakLine: false,
							cleanBefore: false
						},
						editorUrl
					);
				});
			}
		}

		if (
			event.data.key === 'RegisterMessage' &&
			event.data.value === 'EventShortcut'
		) {
			let args = undefined;
			let keyCode = event.data.args.keyCode;
			let keyCodeValid =
				(keyCode > 47 && keyCode < 91) ||
				(keyCode > 95 && keyCode < 106) ||
				(keyCode > 111 && keyCode < 124);

			if (keyCodeValid) {
				args = '';
				args += event.data.args.ctrKeyPress ? 'ctrl+' : '';
				args += event.data.args.altKeyPress ? 'alt+' : '';
				args += event.data.args.shiftKeyPress ? 'shift+' : '';
				args += event.data.args.key.toLowerCase();
			}

			this.props.commonActions.preencherAtalho(args);
		}
	};

	render() {
		let laudoIdPreview = this.props.detalhes
			? this.props.detalhes.laudo
			: new Date().getTime();
		return (
			<React.Fragment>
				<ModalLiberacaoParcial isGoBack={true} />
				<ModalLiberacaoTotal isGoBack={true} />
				<LaudoPreview
					stringRtf={this.state.stringRtf}
					laudoId={laudoIdPreview}
					etapa={this.props.etapaAtual}
					show={this.state.showPreview}
					setShow={() => this.setState({ showPreview: false })}
				/>
				<ModalConfirmar
					close={this.state.modalConfirmarClick}
					toggleModalConfirmar={() =>
						this.setState({
							modalConfirmar: !this.state.modalConfirmar
						})
					}
					type={'ok'}
					backdrop='static'
					keyboard={false}
					showModalConfirmar={this.state.modalConfirmar}
					titulo={this.state.modalConfirmarTitulo}
					mensagem={this.state.modalConfirmarMensagem}
					confirmar={this.state.modalConfirmarClick}
				/>
				<EditorPage
					alturaEditor={this.getAltura.bind(this)}
					carregarEditor={this.carregarEditor.bind(this)}
					showIconSave={this.state.showIconSave}
					showEditor={this.props.showEditor}
					larguraEditor={this.props.larguraEditor}
				/>
			</React.Fragment>
		);
	}

	getCabecalhoRodape = async () => {
		let laudo = this.props.detalhes && this.props.detalhes.laudo;
		await Promise.all([WebapiCommon.obterCabecalhoERodape(laudo)]).then(
			response => {
				this.props.editorActions.editorHeaderFooter(response[0]);
			}
		);
	};
}
const mapStateToProps = state => {
	return {
		lang: state.commonReducer.lang,
		usuario: state.usuario,
		altura: state.commonReducer.altura,
		detalhes: state.commonReducer.detalhes,
		listagem: state.commonReducer.listagem,
		editorCarregado: state.commonReducer.editorCarregado,
		editorInicializado: state.commonReducer.editorInicializado,
		showEditor: state.commonReducer.showEditor,
		textoInicial: state.commonReducer.textoInicial,
		autosaveEditor: state.commonReducer.autosaveEditor,
		laudarEtapaRequest: state.commonReducer.laudarEtapaRequest,
		etapaAtual: state.commonReducer.etapaAtual,
		larguraEditor: state.commonReducer.larguraEditor,
		exameFinalizado: state.commonReducer.exameFinalizado,
		laudoTextoId: state.editor.idRtf,
		medExecutante: state.editor.medExecutante,
		medRevisor: state.editor.medRevisor,
		status: state.editor.status,
		mensagem: state.editor.mensagem,
		tipo: state.editor.tipo,
		cabecalhoRodape: state.editor.headerFooterRtf,
		liberacaoParcialHabilitada:
			state.modalLiberacaoParcial.liberacaoParcialHabilitada
	};
};

const mapDispatchToProps = dispatch => {
	return {
		commonActions: bindActionCreators(commonActions, dispatch),
		certificacaoActions: bindActionCreators(certificacaoActions, dispatch),
		editorActions: bindActionCreators(editorActions, dispatch),
		modalLiberarActions: bindActionCreators(liberarParcialActions, dispatch)
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(EditorContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/editor/editor.container.js